export type Language = 'en' | 'fa' | 'ps';

const messages = {
  en: {
    overview: 'Overview', users: 'Users', teams: 'Teams', players: 'Players',
    tournaments: 'Tournaments', matches: 'Matches', analytics: 'Standings & stats',
    venues: 'Courts & venues', notifications: 'Notifications', settings: 'Settings', logout: 'Sign out',
    adminPanel: 'Admin control center', search: 'Search', add: 'Add new',
    loading: 'Loading…', retry: 'Try again', noData: 'No records found',
    save: 'Save changes', cancel: 'Cancel', actions: 'Actions', status: 'Status',
    welcome: 'Welcome back', liveNow: 'Live now', upcoming: 'Scheduled', completed: 'Completed',
  },
  fa: {
    overview: 'نمای کلی', users: 'کاربران', teams: 'تیم‌ها', players: 'بازیکنان',
    tournaments: 'رقابت‌ها', matches: 'مسابقات', analytics: 'جدول و آمار',
    venues: 'سالون‌ها و میدان‌ها', notifications: 'اعلان‌ها', settings: 'تنظیمات', logout: 'خروج',
    adminPanel: 'مرکز مدیریت', search: 'جستجو', add: 'افزودن', loading: 'در حال بارگذاری…',
    retry: 'تلاش دوباره', noData: 'موردی یافت نشد', save: 'ذخیره تغییرات', cancel: 'لغو',
    actions: 'عملیات', status: 'وضعیت', welcome: 'خوش آمدید', liveNow: 'زنده',
    upcoming: 'برنامه‌ریزی شده', completed: 'پایان‌یافته',
  },
  ps: {
    overview: 'لنډیز', users: 'کاروونکي', teams: 'لوبډلې', players: 'لوبغاړي',
    tournaments: 'سیالۍ', matches: 'لوبې', analytics: 'جدول او شمېرې',
    venues: 'میدانونه او سالونونه', notifications: 'خبرتیاوې', settings: 'امستنې', logout: 'وتل',
    adminPanel: 'د مدیریت مرکز', search: 'لټون', add: 'نوی اضافه کړئ', loading: 'بارېږي…',
    retry: 'بیا هڅه', noData: 'هیڅ معلومات ونه موندل شول', save: 'بدلونونه خوندي کړئ', cancel: 'لغوه',
    actions: 'کړنې', status: 'حالت', welcome: 'ښه راغلاست', liveNow: 'ژوندۍ',
    upcoming: 'مهالویش شوی', completed: 'بشپړ شوی',
  },
} as const;

export type MessageKey = keyof typeof messages.en;
export const direction = (language: Language) => language === 'en' ? 'ltr' : 'rtl';
export const translate = (language: Language, key: MessageKey): string => messages[language][key];
